import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5be1cd82"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "element-loading-text": "数据涉及到大量的查询计算过程，请耐心等待......",
  "element-loading-background": "rgba(0, 0, 0, 0.5)",
  style: {"padding-top":"0px","overflow-y":"hidden"}
}
const _hoisted_2 = { style: {"height":"50px","overflow-y":"hidden","line-height":"50px","font-size":"14px","font-weight":"900","margin-top":"-10px"} }
const _hoisted_3 = {
  key: 1,
  style: {"float":"left","width":"90px","color":"#00a9fc"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","text-align":"center","color":"red","width":"calc(100% - 210px)"} }, null, -1))
const _hoisted_5 = {
  key: 3,
  style: {"float":"right"}
}
const _hoisted_6 = { style: {"width":"100%"} }
const _hoisted_7 = { style: {"clear":"both"} }
const _hoisted_8 = { style: {"padding-bottom":"0px"} }
const _hoisted_9 = { class: "el-alert__content" }
const _hoisted_10 = { class: "el-alert__title" }
const _hoisted_11 = { class: "el-alert__content" }
const _hoisted_12 = { class: "el-alert__title" }
const _hoisted_13 = { class: "el-alert__content" }
const _hoisted_14 = { class: "el-alert__title" }
const _hoisted_15 = { style: {"font-weight":"900","font-size":"14px"} }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "（该子目录信息仅按业务周期统计）", -1))
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { key: 4 }
const _hoisted_22 = {
  key: 5,
  style: {"margin-left":"20px"}
}
const _hoisted_23 = {
  key: 8,
  class: "count-search"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 0,
  ref: "divGrossProfitChart",
  style: {"width":"100%","height":"300px"}
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { style: {"margin-top":"10px","width":"100%"} }
const _hoisted_28 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"70px"} }, " 币制 ", -1))
const _hoisted_30 = { style: {"float":"left","width":"150px"} }
const _hoisted_31 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"70px"} }, " 利润 ", -1))
const _hoisted_33 = { style: {"float":"left","width":"150px"} }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  style: {"font-weight":"900","float":"left","width":"70px"}
}
const _hoisted_36 = {
  key: 1,
  style: {"float":"left","width":"150px"}
}
const _hoisted_37 = {
  key: 2,
  style: {"font-weight":"900","float":"left","width":"70px"}
}
const _hoisted_38 = {
  key: 3,
  style: {"float":"left","width":"150px"}
}
const _hoisted_39 = { style: {"padding-top":"10px","font-weight":"900","line-height":"36px"} }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_42 = {
  key: 2,
  style: {"width":"100%","text-align":"center","line-height":"40px"}
}
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { style: {"margin-top":"15px"} }
const _hoisted_46 = { style: {"margin-top":"10px","width":"100%"} }
const _hoisted_47 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"50px"} }, " 币制 ", -1))
const _hoisted_49 = { style: {"float":"left","width":"150px"} }
const _hoisted_50 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"50px"} }, " 总金额 ", -1))
const _hoisted_52 = { style: {"float":"left","width":"150px"} }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"50px"} }, " 已开票 ", -1))
const _hoisted_56 = { style: {"float":"left","width":"150px"} }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"50px"} }, " 未开票 ", -1))
const _hoisted_60 = { style: {"float":"left","width":"150px"} }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"50px"} }, " 已核销 ", -1))
const _hoisted_64 = { style: {"float":"left","width":"150px"} }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"50px","margin-left":"60px"} }, " 逾期 ", -1))
const _hoisted_67 = { style: {"float":"left","width":"150px"} }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"50px","margin-left":"60px"} }, " 坏账 ", -1))
const _hoisted_70 = { style: {"float":"left","width":"150px"} }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"50px"} }, " 未核销 ", -1))
const _hoisted_74 = { style: {"float":"left","width":"150px"} }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"50px","margin-left":"60px"} }, " 逾期 ", -1))
const _hoisted_77 = { style: {"float":"left","width":"150px"} }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = {
  key: 1,
  style: {"width":"100%","text-align":"center","line-height":"40px"}
}
const _hoisted_80 = {
  key: 2,
  style: {"margin-top":"10px"}
}
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应收合计：", -1))
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = {
  key: 2,
  style: {"padding-left":"10px"}
}
const _hoisted_87 = { key: 3 }
const _hoisted_88 = { key: 4 }
const _hoisted_89 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已收合计：", -1))
const _hoisted_91 = { key: 0 }
const _hoisted_92 = { key: 1 }
const _hoisted_93 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "成本合计：", -1))
const _hoisted_95 = { key: 0 }
const _hoisted_96 = { key: 1 }
const _hoisted_97 = {
  key: 2,
  style: {"color":"red","font-weight":"900","padding-left":"10px"}
}
const _hoisted_98 = {
  key: 3,
  style: {"padding-left":"10px"}
}
const _hoisted_99 = { key: 4 }
const _hoisted_100 = { key: 5 }
const _hoisted_101 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "结算价合计：", -1))
const _hoisted_103 = { key: 0 }
const _hoisted_104 = { key: 1 }
const _hoisted_105 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "利息合计：", -1))
const _hoisted_107 = { key: 0 }
const _hoisted_108 = { key: 1 }
const _hoisted_109 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "结算利润合计：", -1))
const _hoisted_111 = { key: 0 }
const _hoisted_112 = { key: 1 }
const _hoisted_113 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应发合计：", -1))
const _hoisted_115 = { key: 0 }
const _hoisted_116 = { key: 1 }
const _hoisted_117 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "实发合计：", -1))
const _hoisted_119 = { key: 0 }
const _hoisted_120 = { key: 1 }
const _hoisted_121 = { style: {"clear":"both","padding-top":"5px"} }
const _hoisted_122 = { key: 0 }
const _hoisted_123 = { style: {"float":"left"} }
const _hoisted_124 = { key: 0 }
const _hoisted_125 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_126 = { key: 1 }
const _hoisted_127 = ["onClick"]
const _hoisted_128 = { key: 2 }
const _hoisted_129 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_130 = { key: 3 }
const _hoisted_131 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_132 = { key: 4 }
const _hoisted_133 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_134 = { key: 5 }
const _hoisted_135 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_136 = { key: 6 }
const _hoisted_137 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_138 = { key: 7 }
const _hoisted_139 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_140 = { key: 8 }
const _hoisted_141 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_142 = { key: 9 }
const _hoisted_143 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_144 = { key: 10 }
const _hoisted_145 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_146 = { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }
const _hoisted_147 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_148 = {
  ref: "detailFormPie",
  class: "count",
  style: {"width":"100%","height":"300px"}
}
const _hoisted_149 = { style: {"clear":"both","margin-top":"-20px"} }
const _hoisted_150 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_151 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_152 = { key: 0 }
const _hoisted_153 = ["onClick"]
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 应发金额公式 ", -1))
const _hoisted_156 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_157 = { style: {"clear":"both","font-weight":"900","font-size":"13px","line-height":"24px","color":"#909399"} }
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { title: "数值表示可以由用户自行填入数字" }, "数值", -1))
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","font-weight":"900","font-size":"13px","line-height":"24px","color":"#909399"} }, " 点击“”内的文字或符号可直接添加。 ", -1))
const _hoisted_160 = {
  key: 0,
  style: {"clear":"both","font-weight":"900","font-size":"13px","line-height":"24px","color":"#67c23a"}
}
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 选择业务员 ", -1))
const _hoisted_163 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 应发金额 ", -1))
const _hoisted_166 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_167 = { style: {"float":"left"} }
const _hoisted_168 = {
  key: 0,
  style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"13px"}
}
const _hoisted_169 = { key: 4 }
const _hoisted_170 = { key: 0 }
const _hoisted_171 = { key: 1 }
const _hoisted_172 = { key: 3 }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 实发 ", -1))
const _hoisted_175 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_176 = { style: {"width":"100% !important"} }
const _hoisted_177 = { key: 0 }
const _hoisted_178 = { key: 1 }
const _hoisted_179 = {
  key: 2,
  style: {"font-size":"13px","color":"#fe995b","font-weight":"900","margin-left":"10px"}
}
const _hoisted_180 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_181 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_182 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_183 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_184 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_185 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_186 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_187 = ["onClick"]
const _hoisted_188 = ["onClick"]
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left"} }, "历史记录", -1))
const _hoisted_190 = { style: {"float":"right"} }
const _hoisted_191 = { key: 0 }
const _hoisted_192 = { style: {"font-size":"13px"} }
const _hoisted_193 = ["onClick"]
const _hoisted_194 = { style: {"float":"left"} }
const _hoisted_195 = { style: {"font-weight":"900"} }
const _hoisted_196 = { key: 0 }
const _hoisted_197 = {
  key: 0,
  style: {"margin-left":"3px","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
}
const _hoisted_198 = {
  key: 1,
  style: {"margin-left":"3px","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
}
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_200 = {
  key: 0,
  style: {"line-height":"28px"}
}
const _hoisted_201 = {
  key: 0,
  style: {"clear":"both"}
}
const _hoisted_202 = {
  key: 0,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_203 = {
  key: 1,
  style: {"float":"left"}
}
const _hoisted_204 = {
  key: 0,
  style: {}
}
const _hoisted_205 = { key: 0 }
const _hoisted_206 = {
  key: 0,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_207 = { style: {"font-weight":"900"} }
const _hoisted_208 = {
  key: 1,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_209 = { style: {"font-weight":"900"} }
const _hoisted_210 = {
  key: 2,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_211 = { style: {"font-weight":"900"} }
const _hoisted_212 = {
  key: 3,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_213 = { style: {} }
const _hoisted_214 = ["onClick"]
const _hoisted_215 = ["onClick"]
const _hoisted_216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_217 = { key: 1 }
const _hoisted_218 = { key: 0 }
const _hoisted_219 = { key: 1 }
const _hoisted_220 = {
  key: 0,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_221 = { style: {"font-weight":"900"} }
const _hoisted_222 = {
  key: 1,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_223 = { style: {"font-weight":"900"} }
const _hoisted_224 = {
  key: 2,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_225 = { style: {"font-weight":"900"} }
const _hoisted_226 = {
  key: 3,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_227 = { style: {} }
const _hoisted_228 = ["onClick"]
const _hoisted_229 = ["onClick"]
const _hoisted_230 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_231 = { key: 1 }
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_233 = {
  key: 1,
  style: {"clear":"both"}
}
const _hoisted_234 = { key: 0 }
const _hoisted_235 = {
  key: 0,
  style: {"text-indent":"20px"}
}
const _hoisted_236 = { style: {"font-weight":"900"} }
const _hoisted_237 = {
  key: 1,
  style: {"text-indent":"20px"}
}
const _hoisted_238 = { style: {"font-weight":"900"} }
const _hoisted_239 = {
  key: 2,
  style: {"text-indent":"20px"}
}
const _hoisted_240 = { style: {"font-weight":"900"} }
const _hoisted_241 = {
  key: 3,
  style: {"text-indent":"20px"}
}
const _hoisted_242 = { style: {} }
const _hoisted_243 = { key: 1 }
const _hoisted_244 = {
  key: 0,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_245 = {
  key: 1,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_246 = { style: {"float":"left","text-indent":"20px"} }
const _hoisted_247 = {
  key: 0,
  style: {"text-indent":"20px"}
}
const _hoisted_248 = { style: {"font-weight":"900"} }
const _hoisted_249 = {
  key: 1,
  style: {"text-indent":"20px"}
}
const _hoisted_250 = { style: {"font-weight":"900"} }
const _hoisted_251 = {
  key: 2,
  style: {"text-indent":"20px"}
}
const _hoisted_252 = { style: {"font-weight":"900"} }
const _hoisted_253 = {
  key: 3,
  style: {"text-indent":"20px"}
}
const _hoisted_254 = { style: {} }
const _hoisted_255 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_257 = {
  key: 1,
  style: {"height":"40px","line-height":"40px","text-align":"center","font-size":"14px","color":"#999"}
}
const _hoisted_258 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"90px"} }, null, -1))
const _hoisted_259 = { style: {"clear":"both"} }
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 编辑 ", -1))
const _hoisted_261 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_262 = { style: {"width":"100% !important"} }
const _hoisted_263 = { style: {"float":"left"} }
const _hoisted_264 = {
  key: 0,
  style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"13px"}
}
const _hoisted_265 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"90px"} }, null, -1))
const _hoisted_266 = { style: {"clear":"both"} }
const _hoisted_267 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 毛利润明细 ", -1))
const _hoisted_268 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_269 = { style: {"width":"100%"} }
const _hoisted_270 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_271 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应收合计：", -1))
const _hoisted_272 = { key: 0 }
const _hoisted_273 = { key: 1 }
const _hoisted_274 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_275 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应付合计：", -1))
const _hoisted_276 = { key: 0 }
const _hoisted_277 = { key: 1 }
const _hoisted_278 = {
  key: 2,
  style: {"color":"red","font-weight":"900","padding-left":"10px"}
}
const _hoisted_279 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_280 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "毛利合计：", -1))
const _hoisted_281 = { key: 0 }
const _hoisted_282 = { key: 1 }
const _hoisted_283 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_284 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "综合毛利率：", -1))
const _hoisted_285 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_286 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_287 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_288 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_289 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_290 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_291 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_292 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_293 = ["onClick"]
const _hoisted_294 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_295 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 核销记录 ", -1))
const _hoisted_296 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_297 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_298 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_299 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_300 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_301 = {
  key: 1,
  style: {"height":"30px","line-height":"30px"}
}
const _hoisted_302 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_303 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_304 = {
  key: 1,
  style: {"height":"30px","line-height":"30px"}
}
const _hoisted_305 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_306 = {
  key: 1,
  style: {"height":"30px","line-height":"30px"}
}
const _hoisted_307 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_308 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_309 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Document = _resolveComponent("Document")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_miezz_month_choose = _resolveComponent("miezz-month-choose")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_ArrowUpBold = _resolveComponent("ArrowUpBold")!
  const _component_Minus = _resolveComponent("Minus")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.FinancialManagement_StatisticalAnalysis_Overview == true)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChangeChannel('0'))),
            style: {"float":"left","width":"50px","cursor":"pointer"}
          }, " 总览 "))
        : _createCommentVNode("", true),
      (_ctx.FinancialManagement_StatisticalAnalysis_SalespersonRelated == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 业务员相关 "))
        : _createCommentVNode("", true),
      (_ctx.FinancialManagement_StatisticalAnalysis_CustomerRelated == true)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeChannel('2'))),
            style: {"float":"left","cursor":"pointer","width":"70px"}
          }, " 客户相关 "))
        : _createCommentVNode("", true),
      _hoisted_4,
      (_ctx.type!='2')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.isFinancialCycle==false)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  style: {"cursor":"pointer"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onTime()))
                }, "切换至财务周期"))
              : _createCommentVNode("", true),
            (_ctx.isFinancialCycle==true)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  style: {"cursor":"pointer"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onTime()))
                }, "切换至业务周期"))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.isLeft==false)
        ? (_openBlock(), _createBlock(_component_el_card, {
            key: 0,
            class: "left"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_form, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "业务员" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            "no-data-text": '无匹配信息',
                            "no-match-text": '无匹配信息',
                            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangeSelectSaler())),
                            modelValue: _ctx.salerId,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.salerId) = $event)),
                            filterable: "",
                            placeholder: "请选择"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companys, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.Value,
                                  label: item.Label,
                                  value: item.Value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.FinancialManagement_StatisticalAnalysis_SalespersonRelated_CollectionProgress==true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "el-alert el-alert--info is-dark",
                      style: _normalizeStyle(_ctx.type == '0' ? 'background-color: #00a9fc;color:#fff;' : ''),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onChangeType('0')))
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Document)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 收款进度 ")
                        ])
                      ])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.FinancialManagement_StatisticalAnalysis_SalespersonRelated_GrossProfit==true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "el-alert el-alert--info is-dark",
                      style: _normalizeStyle(_ctx.type == '3' ? 'background-color: #00a9fc;color:#fff;' : ''),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChangeType('3')))
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Document)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 毛利润 ")
                        ])
                      ])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.FinancialManagement_StatisticalAnalysis_SalespersonRelated_SalespersonPerformance==true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "el-alert el-alert--info is-dark",
                      style: _normalizeStyle(_ctx.type == '2' ? 'background-color: #00a9fc;color:#fff;' : ''),
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onChangeType('2')))
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Document)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 业务员绩效 ")
                        ])
                      ])
                    ], 4))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.isLeft==true?'middle':'isMiddle'),
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isLeft = !_ctx.isLeft))
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_ArrowRight)
          ]),
          _: 1
        })
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.isLeft==false?'right':'isRight')
      }, [
        _createVNode(_component_miezz_month_choose, {
          modelValue: _ctx.month,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.month) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              (_ctx.type == '0' || _ctx.type == '')
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "收款进度"))
                : (_ctx.type == '1')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, "付款进度"))
                  : (_ctx.type == '2')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                        _createTextVNode(" 业务员绩效 "),
                        _hoisted_19
                      ]))
                    : (_ctx.type == '3')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, "毛利润"))
                      : (_ctx.type == '4')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, "实际利润"))
                        : _createCommentVNode("", true),
              (_ctx.type == '3' && _ctx.result.Rate!=null && _ctx.result.Rate!=undefined && _ctx.result.Rate!='')
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, " 参考汇率 " + _toDisplayString(_ctx.result.Rate), 1))
                : _createCommentVNode("", true),
              (_ctx.type == '3')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 6,
                    style: {"color":"#f6a46d","cursor":"pointer","float":"right"},
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onGrossProfitDetail()))
                  }, " 查看明细 "))
                : _createCommentVNode("", true),
              ((_ctx.type == '0' || _ctx.type == '' || _ctx.type == '1') && _ctx.isFinancialCycle!=true)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 7,
                    style: {"color":"#f6a46d","cursor":"pointer","margin-left":"10px"},
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onNoBill()))
                  }, " 委托书（无账单）票数：" + _toDisplayString(_ctx.result.PoolCount), 1))
                : _createCommentVNode("", true),
              (_ctx.type=='2')
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createVNode(_component_miezz_input, {
                      modelValue: _ctx.searchForm.CustomerName,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.searchForm.CustomerName) = $event)),
                      placeholder: "请填写客户名称关键词"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_miezz_button, {
                      model: _ctx.btnSearch,
                      onHandleClick: _ctx.onStat
                    }, null, 8, ["model", "onHandleClick"]),
                    _createVNode(_component_miezz_button, {
                      model: _ctx.btnSearchReset,
                      onHandleClick: _ctx.clearSearch
                    }, null, 8, ["model", "onHandleClick"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.type=='3' || _ctx.type=='4')
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  (_ctx.type=='3' && _ctx.isGrossProfitChart==true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, null, 512))
                    : _createCommentVNode("", true),
                  (_ctx.result.Profit != _ctx.nul && _ctx.result.Profit.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.Profit, (p, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            style: {"clear":"both","margin-top":"10px","border-bottom":"1px solid #eee","padding-bottom":"50px"},
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _hoisted_29,
                                _createElementVNode("div", _hoisted_30, _toDisplayString(p.CurrencySystemCode), 1)
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _hoisted_32,
                                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.formatNumber(p.Profit)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left","width":"150px"},
                                  onClick: ($event: any) => (_ctx.onDetail(7,p.CurrencySystemId,p.CurrencySystemCode,'毛利润'))
                                }, " 查看组成 ", 8, _hoisted_34),
                                (_ctx.currencySystem?.ShowTaxRate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, " 应收税额： "))
                                  : _createCommentVNode("", true),
                                (_ctx.currencySystem?.ShowTaxRate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.formatNumber(p.CollectionTaxAmount)), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.currencySystem?.ShowTaxRate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, " 应付税额： "))
                                  : _createCommentVNode("", true),
                                (_ctx.currencySystem?.ShowTaxRate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.formatNumber(p.PaymentTaxAmount)), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        }), 128)),
                        _createElementVNode("div", _hoisted_39, [
                          _createTextVNode(" 合计：CNY " + _toDisplayString(_ctx.formatNumber(_ctx.result.Total)) + " ", 1),
                          _createElementVNode("span", {
                            style: {"color":"#f6a46d","cursor":"pointer","margin-left":"20px"},
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onSumLink()))
                          }, " 查看明细 "),
                          _hoisted_40,
                          (_ctx.type=='3')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_41, "已核销利润（已核销应收金额-已核销应付金额，折算为CNY得出）：CNY " + _toDisplayString(_ctx.formatNumber(_ctx.result.RealityProfit)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_42, " 暂无数据 "))
                ]))
              : _createCommentVNode("", true),
            (_ctx.type=='0' || _ctx.type=='1')
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  (_ctx.result.Item != _ctx.nul && _ctx.result.Item.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.Item, (p, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            style: {"clear":"both","margin-top":"10px","border-bottom":"1px solid #eee","padding-bottom":"50px"},
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_45, [
                              _createVNode(_component_el_progress, {
                                "text-inside": true,
                                "stroke-width": 22,
                                percentage: p.Progress
                              }, null, 8, ["percentage"])
                            ]),
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, [
                                _hoisted_48,
                                _createElementVNode("div", _hoisted_49, _toDisplayString(p.CurrencySystemCode), 1)
                              ]),
                              _createElementVNode("div", _hoisted_50, [
                                _hoisted_51,
                                _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.formatNumber(p.Total)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onDetail(
                      0,
                      p.CurrencySystemId,
                      p.CurrencySystemCode,
                      '总金额'
                    )
                  )
                                }, " 查看组成 ", 8, _hoisted_53)
                              ]),
                              _createElementVNode("div", _hoisted_54, [
                                _hoisted_55,
                                _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.formatNumber(p.Invoice)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onDetail(
                      1,
                      p.CurrencySystemId,
                      p.CurrencySystemCode,
                      '已开票'
                    )
                  )
                                }, " 查看组成 ", 8, _hoisted_57)
                              ]),
                              _createElementVNode("div", _hoisted_58, [
                                _hoisted_59,
                                _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.formatNumber(p.NoInvoice)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onDetail(
                      2,
                      p.CurrencySystemId,
                      p.CurrencySystemCode,
                      '未开票'
                    )
                  )
                                }, " 查看组成 ", 8, _hoisted_61)
                              ]),
                              _createElementVNode("div", _hoisted_62, [
                                _hoisted_63,
                                _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.formatNumber(p.Settlement)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onDetail(
                      3,
                      p.CurrencySystemId,
                      p.CurrencySystemCode,
                      '已核销'
                    )
                  )
                                }, " 查看组成 ", 8, _hoisted_65),
                                _hoisted_66,
                                _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.formatNumber(p.SettlementOverdue)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onDetail(
                      5,
                      p.CurrencySystemId,
                      p.CurrencySystemCode,
                      '已核销逾期'
                    )
                  )
                                }, " 查看组成 ", 8, _hoisted_68),
                                _hoisted_69,
                                _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.formatNumber(p.BadSettlement)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left","width":"150px"},
                                  onClick: ($event: any) => (
                    _ctx.onDetail(
                      8,
                      p.CurrencySystemId,
                      p.CurrencySystemCode,
                      '坏账'
                    )
                  )
                                }, " 查看组成 ", 8, _hoisted_71),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left","font-size":"14px"},
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onSettlementList()))
                                }, " 核销记录 ")
                              ]),
                              _createElementVNode("div", _hoisted_72, [
                                _hoisted_73,
                                _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.formatNumber(p.NoSettlement)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onDetail(
                      4,
                      p.CurrencySystemId,
                      p.CurrencySystemCode,
                      '未核销'
                    )
                  )
                                }, " 查看组成 ", 8, _hoisted_75),
                                _hoisted_76,
                                _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.formatNumber(p.NoSettlementOverdue)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onDetail(
                      6,
                      p.CurrencySystemId,
                      p.CurrencySystemCode,
                      '未核销逾期'
                    )
                  )
                                }, " 查看组成 ", 8, _hoisted_78)
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_79, " 暂无数据 "))
                ]))
              : (_ctx.type=='2')
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                    (_ctx.items != null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _hoisted_83,
                            (_ctx.items.Data.CollectionString!=null && _ctx.items.Data.CollectionString!='')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(_ctx.items.Data.CollectionString), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_85, "CNY 0")),
                            (_ctx.currencySystem?.ShowTaxRate)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_86, "应收税额："))
                              : _createCommentVNode("", true),
                            (_ctx.currencySystem?.ShowTaxRate)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_87, _toDisplayString(_ctx.items.Data.CollectionTaxAmountString), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_88, "CNY 0"))
                          ]),
                          _createElementVNode("div", _hoisted_89, [
                            _hoisted_90,
                            (_ctx.items.Data.CollectionedString!=null && _ctx.items.Data.CollectionedString!='')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_91, _toDisplayString(_ctx.items.Data.CollectionedString), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_92, "CNY 0"))
                          ]),
                          _createElementVNode("div", _hoisted_93, [
                            _hoisted_94,
                            (_ctx.items.Data.CostString!=null && _ctx.items.Data.CostString!='')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_95, _toDisplayString(_ctx.items.Data.CostString), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_96, "CNY 0")),
                            (_ctx.items.Data.IsShare == true)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_97, [
                                  _createTextVNode(" 存在未分摊应付费用 "),
                                  _createElementVNode("span", {
                                    style: {"margin-left":"10px","cursor":"pointer","color":"#fe995b"},
                                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onSalerShare()))
                                  }, " 查看账单 ")
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.currencySystem?.ShowTaxRate)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_98, "应付税额："))
                              : _createCommentVNode("", true),
                            (_ctx.currencySystem?.ShowTaxRate)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_99, _toDisplayString(_ctx.items.Data.CostTaxAmountString), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_100, "CNY 0"))
                          ]),
                          _createElementVNode("div", _hoisted_101, [
                            _hoisted_102,
                            (_ctx.items.Data.SettlementString!=null && _ctx.items.Data.SettlementString!='')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_103, _toDisplayString(_ctx.items.Data.SettlementString), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_104, "CNY 0"))
                          ]),
                          _createElementVNode("div", _hoisted_105, [
                            _hoisted_106,
                            (_ctx.items.Data.InterestString!=null && _ctx.items.Data.InterestString!='')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_107, _toDisplayString(_ctx.items.Data.InterestString), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_108, "CNY 0"))
                          ]),
                          _createElementVNode("div", _hoisted_109, [
                            _hoisted_110,
                            (_ctx.items.Data.SumSalerProfit!=null && _ctx.items.Data.SumSalerProfit!='')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_111, _toDisplayString(_ctx.items.Data.SumSalerProfit), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_112, "CNY 0"))
                          ]),
                          _createElementVNode("div", _hoisted_113, [
                            _hoisted_114,
                            (_ctx.items.Data.PaymentString!=null && _ctx.items.Data.PaymentString!='')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_115, _toDisplayString(_ctx.items.Data.PaymentString), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_116, "CNY 0")),
                            (_ctx.isSalerPerformance==true && _ctx.FinancialManagement_StatisticalAnalysis_SalespersonRelated_EditCalculationFormula==true)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 2,
                                  title: "设置公式",
                                  style: {"cursor":"pointer","margin-left":"10px","color":"#00a5fb","padding-top":"2px"},
                                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onFormula()))
                                }, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Setting)
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.isSalerPerformance==true && _ctx.items.Data.IsPerformance==true && _ctx.FinancialManagement_StatisticalAnalysis_SalespersonRelated_EditPayableAmount==true)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 3,
                                  title: "编辑应付金额",
                                  style: {"cursor":"pointer","margin-left":"10px","color":"#00a5fb","padding-top":"2px"},
                                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onCount(_ctx.items.Data)))
                                }, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Edit)
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_117, [
                            _hoisted_118,
                            (_ctx.items.Data.ActualString!=null && _ctx.items.Data.ActualString!='')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_119, _toDisplayString(_ctx.items.Data.ActualString), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_120, "CNY 0")),
                            (_ctx.isSalerPerformance==true && _ctx.items.Data.IsPerformance==true && _ctx.FinancialManagement_StatisticalAnalysis_SalespersonRelated_EditActualPaymentAmount==true)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 2,
                                  title: "编辑实发金额",
                                  style: {"cursor":"pointer","margin-left":"10px","color":"#00a5fb","padding-top":"2px"},
                                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onSettlement(_ctx.items.Data)))
                                }, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Edit)
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_121, [
                      _createVNode(_component_miezz_page_list, {
                        modelValue: _ctx.items,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.items) = $event)),
                        onHandleBottomButtonClick: _ctx.handleBottomButtonClick
                      }, {
                        "column-header": _withCtx(({ model }) => [
                          (model.Prop == 'PaymentString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                _createElementVNode("div", _hoisted_123, _toDisplayString(model.Label), 1),
                                (_ctx.isSalerPerformance==false)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      title: "设置公式",
                                      style: {"float":"left","cursor":"pointer","margin-left":"2px","color":"#00a5fb","margin-top":"2px"},
                                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onFormula()))
                                    }, [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Setting)
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        column: _withCtx(({ model,row }) => [
                          (model.Prop == 'BookingNo')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                _createElementVNode("div", _hoisted_125, _toDisplayString(_ctx.isString(row.BookingNo)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'ClientCompanyName')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (_ctx.onClientCompany(row)),
                                  style: {"color":"#fe995b","cursor":"pointer","width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                                }, _toDisplayString(_ctx.isString(row.ClientCompanyName)), 9, _hoisted_127)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'SalerName')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                _createElementVNode("div", _hoisted_129, _toDisplayString(_ctx.isString(row.SalerName)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'CollectionString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                                _createElementVNode("div", _hoisted_131, _toDisplayString(_ctx.isString(row.CollectionString)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'CollectionTaxAmountString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                _createElementVNode("div", _hoisted_133, _toDisplayString(_ctx.isString(row.CollectionTaxAmountString)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'CollectionedString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                _createElementVNode("div", _hoisted_135, _toDisplayString(_ctx.isString(row.CollectionedString)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'CostString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                                _createElementVNode("div", _hoisted_137, _toDisplayString(_ctx.isString(row.CostString)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'CostTaxAmountString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                _createElementVNode("div", _hoisted_139, _toDisplayString(_ctx.isString(row.CostTaxAmountString)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'SettlementString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                                _createElementVNode("div", _hoisted_141, _toDisplayString(_ctx.isString(row.SettlementString)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'InterestString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                                _createElementVNode("div", _hoisted_143, _toDisplayString(_ctx.isString(row.InterestString)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'SumSalerProfit')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                                _createElementVNode("div", _hoisted_145, _toDisplayString(_ctx.isString(row.SumSalerProfit)), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onHandleBottomButtonClick"])
                    ])
                  ]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2)
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.detailForm.Visible,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.detailForm.Visible) = $event)),
      "show-close": false,
      style: {"width":"60%"},
      top: "10px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _createElementVNode("div", _hoisted_146, _toDisplayString(_ctx.detailForm.Title), 1),
        _createElementVNode("div", _hoisted_147, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_148, null, 512),
        _createElementVNode("div", _hoisted_149, [
          _createVNode(_component_el_table, {
            border: "",
            "tree-props": {children: 'Child', hasChildren: 'hasChildren'},
            "row-key": "Id",
            "default-expand-all": false,
            data: _ctx.detailForm.Details,
            ref: "$billTable",
            style: {"width":"100%","margin-top":"15px"},
            "header-cell-style": { 'text-align': 'left' },
            "cell-style": { 'text-align': 'left' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Name",
                label: _ctx.CompositionType==7?'委托人':'对账对象',
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_150, _toDisplayString(_ctx.isString(scope.row.Name)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Value",
                label: "金额（元）",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_151, [
                    _createTextVNode(_toDisplayString(_ctx.isString(_ctx.formatNumber(scope.row.Value))) + " ", 1),
                    (scope.row.StatPrice!=undefined && scope.row.StatPrice!=null && scope.row.StatPrice!='')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_152, "( " + _toDisplayString(_ctx.formatNumber(scope.row.StatPrice)) + ")", 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Collection",
                label: "操作",
                "show-overflow-tooltip": true,
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.onClientDetail(scope.row)),
                    style: {"cursor":"pointer","color":"#fe995b","width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                  }, " 查看账单 ", 8, _hoisted_153)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _hoisted_154,
        _createVNode(_component_miezz_button_bar, {
          modelValue: _ctx.detailBottomButtons,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.detailBottomButtons) = $event)),
          isBackground: true,
          onHandleClick: _ctx.handleClickDetail
        }, null, 8, ["modelValue", "onHandleClick"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.formulaForm.Visible,
      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.formulaForm.Visible) = $event)),
      "show-close": false,
      style: {"width":"60%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_155,
        _createElementVNode("div", _hoisted_156, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.formulaForm,
          rules: _ctx.formulaFormRules,
          ref: "refformulaForm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "业务员" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.companyName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "公式" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("textarea", {
                  ref: "inputRef",
                  rows: "5",
                  style: {"width":"100%"},
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formulaForm.Formula) = $event)),
                  onBlur: _cache[25] || (_cache[25] = ($event: any) => (_ctx.handleGetResult())),
                  onKeyup: _cache[26] || (_cache[26] = ($event: any) => (_ctx.handleGetResult()))
                }, null, 544), [
                  [_vModelText, _ctx.formulaForm.Formula]
                ]),
                _createElementVNode("div", _hoisted_157, [
                  _createTextVNode(" 仅可输入"),
                  _hoisted_158,
                  _createTextVNode("和“"),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","font-size":"20px","color":"#f6a46d"},
                    onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onClick('+')))
                  }, "+"),
                  _createTextVNode("”、“"),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","font-size":"20px","color":"#f6a46d"},
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.onClick('-')))
                  }, "-"),
                  _createTextVNode("”、 “"),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","font-size":"18px","color":"#f6a46d"},
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.onClick('×')))
                  }, "×"),
                  _createTextVNode("”、“"),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","font-size":"18px","color":"#f6a46d"},
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.onClick('÷')))
                  }, "÷"),
                  _createTextVNode("”、“"),
                  _createElementVNode("span", {
                    style: {"color":"#f6a46d","cursor":"pointer","font-size":"18px"},
                    onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.onClick('(')))
                  }, "("),
                  _createTextVNode("”、“"),
                  _createElementVNode("span", {
                    style: {"color":"#f6a46d","cursor":"pointer","font-size":"18px"},
                    onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.onClick(')')))
                  }, ")"),
                  _createTextVNode("”、 “"),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","color":"#f6a46d"},
                    onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.onClick('IF(,,)')))
                  }, "IF(条件,符合条件的结果,不符合条件的结果)"),
                  _createTextVNode("”、 “"),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","color":"#f6a46d"},
                    onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.onClick('>')))
                  }, ">"),
                  _createTextVNode("”、 “"),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","color":"#f6a46d"},
                    onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.onClick('>=')))
                  }, "≥"),
                  _createTextVNode("”、 “"),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","color":"#f6a46d"},
                    onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.onClick('<')))
                  }, "<"),
                  _createTextVNode("”、 “"),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","color":"#f6a46d"},
                    onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.onClick('<=')))
                  }, "≤"),
                  _createTextVNode("”、 “"),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","color":"#f6a46d"},
                    onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.onClick('=')))
                  }, "="),
                  _createTextVNode("”、 “"),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","color":"#f6a46d"},
                    onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.onClick('应收')))
                  }, "应收"),
                  _createTextVNode("”、 “"),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","color":"#f6a46d"},
                    onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.onClick('应收税额')))
                  }, "应收税额"),
                  _createTextVNode("”、 “"),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","color":"#f6a46d"},
                    onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.onClick('成本')))
                  }, "成本"),
                  _createTextVNode("”、 “"),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","color":"#f6a46d"},
                    onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.onClick('应付税额')))
                  }, "应付税额"),
                  _createTextVNode("”、 “"),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","color":"#f6a46d"},
                    onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.onClick('已收')))
                  }, "已收"),
                  _createTextVNode("”、“"),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","color":"#f6a46d"},
                    onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.onClick('结算价')))
                  }, "结算价"),
                  _createTextVNode("”、“ "),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","color":"#f6a46d"},
                    onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.onClick('逾期利息')))
                  }, "逾期利息"),
                  _createTextVNode("”、“"),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","color":"#f6a46d"},
                    onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.onClick('应收坏账')))
                  }, "应收坏账"),
                  _createTextVNode("”、“"),
                  _createElementVNode("span", {
                    style: {"cursor":"pointer","color":"#f6a46d"},
                    onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.onClick('应付坏账')))
                  }, "应付坏账"),
                  _createTextVNode("。” ")
                ]),
                _hoisted_159,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkResult.Message, (p, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    style: {"clear":"both","color":"#f56c6c","font-weight":"900","font-size":"13px","line-height":"24px"},
                    key: index
                  }, _toDisplayString(p), 1))
                }), 128)),
                (_ctx.checkResult.IsError == false && this.formulaForm.Formula!=null && this.formulaForm.Formula!=undefined && this.formulaForm.Formula!='')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_160, " 录入的公式符合运算规则 "))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _hoisted_161,
        _createVNode(_component_miezz_button_bar, {
          modelValue: _ctx.formulaBottomButtons,
          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.formulaBottomButtons) = $event)),
          isBackground: true,
          onHandleClick: _ctx.handleClickFormula
        }, null, 8, ["modelValue", "onHandleClick"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.visible) = $event)),
      "show-close": false,
      style: {"width":"40%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_162,
        _createElementVNode("div", _hoisted_163, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "业务员" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  "no-data-text": '无匹配信息',
                  "no-match-text": '无匹配信息',
                  modelValue: _ctx.selectSalerId,
                  "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.selectSalerId) = $event)),
                  filterable: "",
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salerFormulas, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.Value,
                        label: item.Label,
                        value: item.Value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_164,
        _createVNode(_component_miezz_button_bar, {
          modelValue: _ctx.quoteBottomButtons,
          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.quoteBottomButtons) = $event)),
          isBackground: true,
          onHandleClick: _ctx.handleClickQuote
        }, null, 8, ["modelValue", "onHandleClick"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.countForm.Visible,
      "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.countForm.Visible) = $event)),
      "show-close": false,
      style: {"width":"50%"},
      top: "10px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_165,
        _createElementVNode("div", _hoisted_166, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.countForm.IsSettlement == false)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              "label-width": "150px",
              model: _ctx.countForm,
              rules: _ctx.countFormRules,
              ref: "refCountForm"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "业务员" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.companyName), 1)
                  ]),
                  _: 1
                }),
                (_ctx.isSalerPerformance == false)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "Booking No"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.bookingNo), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isSalerPerformance == true && _ctx.items.Data.IsOneMonth != true)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: "月份"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          "no-data-text": '无匹配信息',
                          "no-match-text": '无匹配信息',
                          onChange: _cache[53] || (_cache[53] = ($event: any) => (_ctx.onCountByMonth(_ctx.countForm.SelectMonth))),
                          modelValue: _ctx.countForm.SelectMonth,
                          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.countForm.SelectMonth) = $event)),
                          filterable: "",
                          placeholder: "请选择"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countForm.Months, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.Value,
                                label: item.Label,
                                value: item.Value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, { label: "录入方式" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      "no-data-text": '无匹配信息',
                      "no-match-text": '无匹配信息',
                      modelValue: _ctx.countForm.Mode,
                      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.countForm.Mode) = $event)),
                      filterable: "",
                      placeholder: "请选择",
                      onChange: _cache[56] || (_cache[56] = ($event: any) => (_ctx.onChangeCountFormCurrencySystem()))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.EnumSalerInputModeOption, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.Value,
                            label: item.Label,
                            disabled: (item.Value==20 && _ctx.countForm.IsFormula==false)?true:false,
                            value: item.Value
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_167, _toDisplayString(item.Label), 1),
                              (item.Value==20 && _ctx.countForm.IsFormula==false)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_168, " 未设置公式 "))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["label", "disabled", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (_ctx.countForm.Mode == 10 && _ctx.currencys!=null && _ctx.currencys.length>0)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      label: "发放币种",
                      prop: "CurrencySystemId",
                      rules: [
                                        {
                                        required: true,
                                        message: '信息不能为空',
                                        trigger: 'change',
                                        },
                                    ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          "no-data-text": '无匹配信息',
                          "no-match-text": '无匹配信息',
                          modelValue: _ctx.countForm.CurrencySystemId,
                          "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.countForm.CurrencySystemId) = $event)),
                          filterable: "",
                          placeholder: "请选择"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencys, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.Value,
                                label: item.Label,
                                value: item.Value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.countForm.Mode == 20 && _ctx.currencys!=null && _ctx.currencys.length>0)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      label: "发放币种",
                      prop: "CurrencySystemId",
                      rules: [
                                        {
                                        required: true,
                                        message: '信息不能为空',
                                        trigger: 'change',
                                        },
                                    ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          "no-data-text": '无匹配信息',
                          "no-match-text": '无匹配信息',
                          onChange: _cache[58] || (_cache[58] = ($event: any) => (_ctx.onChangeCountFormCurrencySystem())),
                          modelValue: _ctx.countForm.CurrencySystemId,
                          "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.countForm.CurrencySystemId) = $event)),
                          filterable: "",
                          placeholder: "请选择"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencys, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.Value,
                                label: item.Label,
                                value: item.Value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.countForm.Mode == 20)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countForm.Rates, (p, index) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          label: p.CurrencySystemCode +  '汇率',
                          key: index,
                          prop: 'Rates.' + index + '.Rate',
                          rules: [
                                        {
                                        required: true,
                                        message: '信息不能为空',
                                        trigger: 'change',
                                        },
                                    ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              onBlur: _cache[60] || (_cache[60] = ($event: any) => (_ctx.onChangeRate())),
                              modelValue: p.Rate,
                              "onUpdate:modelValue": ($event: any) => ((p.Rate) = $event),
                              disabled: p.CurrencySystemId == _ctx.countForm.CurrencySystemId?true:false
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                          ]),
                          _: 2
                        }, 1032, ["label", "prop"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.currencys!=null && _ctx.currencys.length>0)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 5,
                      label: "金额",
                      prop: "Price",
                      rules: [
                                        {
                                        required: true,
                                        message: '信息不能为空',
                                        trigger: 'change',
                                        },
                                    ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          modelValue: _ctx.countForm.Price,
                          "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.countForm.Price) = $event)),
                          disabled: (_ctx.countForm.IsError!=true && _ctx.countForm.Mode == 20)?true:false,
                          number: true,
                          pattern: "[-0-9.,]"
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["model", "rules"]))
          : (_openBlock(), _createBlock(_component_el_form, {
              key: 1,
              "label-width": "150px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "业务员" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.companyName), 1)
                  ]),
                  _: 1
                }),
                (_ctx.isSalerPerformance == true && _ctx.items.Data.IsOneMonth != true)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "月份"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          "no-data-text": '无匹配信息',
                          "no-match-text": '无匹配信息',
                          onChange: _cache[62] || (_cache[62] = ($event: any) => (_ctx.onCountByMonth(_ctx.countForm.SelectMonth))),
                          modelValue: _ctx.countForm.SelectMonth,
                          "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.countForm.SelectMonth) = $event)),
                          filterable: "",
                          placeholder: "请选择"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countForm.Months, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.Value,
                                label: item.Label,
                                value: item.Value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, { label: "录入方式" }, {
                  default: _withCtx(() => [
                    (_ctx.countForm.Mode == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_170, "手动录入"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_171, "公式录入"))
                  ]),
                  _: 1
                }),
                (_ctx.countForm.Mode == 10)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: "发放币种"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.countForm.CurrencySystemName), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.countForm.Mode == 20)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      label: "发放币种"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.countForm.CurrencySystemName), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.countForm.Mode == 20)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_172, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countForm.Rates, (p, index) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          label: p.CurrencySystemCode +  '汇率',
                          key: index
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(p.Rate), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, { label: "金额" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatNumber(_ctx.countForm.Price)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })),
        (_ctx.countForm.IsSettlement == true)
          ? (_openBlock(), _createBlock(_component_el_alert, {
              key: 2,
              title: "已存在核销记录，不能修改应发金额",
              type: "info",
              closable: false,
              center: true
            }))
          : _createCommentVNode("", true),
        (_ctx.currencys==null || _ctx.currencys==undefined ||  _ctx.currencys.length == 0)
          ? (_openBlock(), _createBlock(_component_el_alert, {
              key: 3,
              title: "没有账单信息，无法添加",
              type: "info",
              closable: false,
              center: true
            }))
          : _createCommentVNode("", true),
        _hoisted_173,
        _createVNode(_component_miezz_button_bar, {
          modelValue: _ctx.countBottomButtons,
          "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.countBottomButtons) = $event)),
          isBackground: true,
          onHandleClick: _ctx.handleClickCount
        }, null, 8, ["modelValue", "onHandleClick"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.settlementForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.settlementForm.Visiable,
          "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.settlementForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"90%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          top: "0px",
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_174,
            _createElementVNode("div", _hoisted_175, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_176, [
              _createVNode(_component_el_card, { style: {"margin-top":"5px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form, {
                    ref: "refSettlementForm",
                    model: _ctx.settlementForm,
                    rules: _ctx.settlementRules
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "总金额",
                        style: {"margin-top":"0px"},
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.settlementForm.TotalString), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "待发放",
                        style: {"margin-top":"-10px"},
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.settlementForm.NoSettlementPriceString), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "已发放",
                        style: {"margin-top":"-10px"},
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.settlementForm.SettlementPriceString!=null && _ctx.settlementForm.SettlementPriceString!=undefined && _ctx.settlementForm.SettlementPriceString!='')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_177, _toDisplayString(_ctx.settlementForm.SettlementPriceString), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_178, _toDisplayString(_ctx.settlementForm.CurrencySystemCode) + "0", 1)),
                          (_ctx.settlementForm.IsAdd == true)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_179, [
                                _createElementVNode("span", {
                                  style: {"cursor":"pointer"},
                                  onClick: _cache[66] || (_cache[66] = 
//@ts-ignore
(...args) => (_ctx.onAddSettlement && _ctx.onAddSettlement(...args)))
                                }, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Plus)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" 添加")
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      (_openBlock(), _createBlock(_component_el_table, {
                        ref: "settlementTable",
                        key: _ctx.settlementTableRandom,
                        data: _ctx.settlementForm.Items
                      }, {
                        default: _withCtx(() => [
                          (_ctx.items.Data.IsOneMonth != true)
                            ? (_openBlock(), _createBlock(_component_el_table_column, {
                                key: 0,
                                prop: "SelectMonth",
                                "show-overflow-tooltip": true,
                                label: "所属月份"
                              }, {
                                default: _withCtx((scope) => [
                                  _createElementVNode("div", _hoisted_180, _toDisplayString(scope.row.DisplayMonth), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_table_column, {
                            prop: "Price",
                            "show-overflow-tooltip": true,
                            label: "发放金额"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_181, _toDisplayString(scope.row.BillCurrencySystemCode) + _toDisplayString(_ctx.formatNumber(scope.row.Price)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "SettlementDateString",
                            "show-overflow-tooltip": true,
                            label: "发放时间"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_182, _toDisplayString(scope.row.SettlementDateString), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "CollectionTitle",
                            "show-overflow-tooltip": true,
                            label: "收款方"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_183, _toDisplayString(scope.row.CollectionTitle), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "PaymentTitle",
                            "show-overflow-tooltip": true,
                            label: "付款方"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_184, _toDisplayString(scope.row.PaymentTitle), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "Remark",
                            "show-overflow-tooltip": true,
                            label: "备注"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_185, _toDisplayString(scope.row.Remark), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "CreatedUserName",
                            "show-overflow-tooltip": true,
                            label: "创建人"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_186, _toDisplayString(scope.row.CreatedUserName), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "操作",
                            width: "100"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("span", {
                                style: {"cursor":"pointer"},
                                onClick: ($event: any) => (_ctx.onEditSettlement(scope.row)),
                                title: "编辑"
                              }, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Edit)
                                  ]),
                                  _: 1
                                })
                              ], 8, _hoisted_187),
                              _createElementVNode("span", {
                                style: {"cursor":"pointer","margin-left":"10px"},
                                onClick: ($event: any) => (_ctx.onDeleteSettlement(scope.$index)),
                                title: "删除"
                              }, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Delete)
                                  ]),
                                  _: 1
                                })
                              ], 8, _hoisted_188)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]))
                    ]),
                    _: 1
                  }, 8, ["model", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_card, { style: {"margin-top":"5px"} }, {
                header: _withCtx(() => [
                  _createElementVNode("div", {
                    style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"},
                    onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.isHistory = !_ctx.isHistory))
                  }, [
                    _hoisted_189,
                    _createElementVNode("div", _hoisted_190, [
                      (_ctx.isHistory==false)
                        ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ArrowDownBold)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ArrowUpBold)
                            ]),
                            _: 1
                          }))
                    ])
                  ]),
                  (_ctx.isHistory==false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_191, [
                        (_ctx.historys.Data.Items!=null && _ctx.historys.Data.Items != undefined && _ctx.historys.Data.Items.length>0)
                          ? (_openBlock(), _createBlock(_component_el_timeline, { key: 0 }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historys.Data.Items, (activity, index) => {
                                  return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                    key: index,
                                    timestamp: activity.CreatedTime,
                                    "hide-timestamp": true
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_192, [
                                        _createElementVNode("div", {
                                          style: {"cursor":"pointer"},
                                          onClick: ($event: any) => (activity.IsOpen = !activity.IsOpen)
                                        }, [
                                          _createElementVNode("div", _hoisted_194, [
                                            _createTextVNode(_toDisplayString(activity.CreatedTime) + " 由", 1),
                                            _createElementVNode("span", _hoisted_195, _toDisplayString(activity.CreatedUserName) + "（" + _toDisplayString(activity.CreatedCompanyNameZh) + "）", 1),
                                            _createTextVNode(_toDisplayString(activity.Title), 1),
                                            (activity.NewLabel!=null && activity.NewLabel!=undefined && activity.NewLabel!='')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_196, "（" + _toDisplayString(activity.NewLabel) + "）", 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          (activity.IsOpen==false && activity.Child!=null && activity.Child!=undefined && activity.Child.length>0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                                                _createVNode(_component_el_icon, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_Plus)
                                                  ]),
                                                  _: 1
                                                })
                                              ]))
                                            : _createCommentVNode("", true),
                                          (activity.IsOpen==true && activity.Child!=null && activity.Child!=undefined && activity.Child.length>0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                                                _createVNode(_component_el_icon, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_Minus)
                                                  ]),
                                                  _: 1
                                                })
                                              ]))
                                            : _createCommentVNode("", true),
                                          _hoisted_199
                                        ], 8, _hoisted_193),
                                        (activity.Child!=null && activity.Child!=undefined && activity.Child.length>0 && activity.IsOpen==true)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_200, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.Child, (p, index1) => {
                                                return (_openBlock(), _createElementBlock("div", { key: index1 }, [
                                                  (p.Title!=null && p.Title!=undefined && p.Title!='')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_201, [
                                                        (p.Child!=null && p.Child!=undefined && p.Child.length>0)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_202, _toDisplayString(p.Title), 1))
                                                          : _createCommentVNode("", true),
                                                        (p.Child!=null && p.Child!=undefined && p.Child.length>0)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_203, [
                                                              (p.Child!=null && p.Child!=undefined && p.Child.length>0)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_204, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Child, (p2, index2) => {
                                                                      return (_openBlock(), _createElementBlock("div", { key: index2 }, [
                                                                        (p2.Child==null || p2.Child==undefined || p2.Child.length<=0)
                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                                                                              (p2.State==4 && (index2==0 || p.IsOpen==true))
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_206, [
                                                                                    _createTextVNode("新增了"),
                                                                                    _createElementVNode("span", _hoisted_207, _toDisplayString(p2.Label), 1),
                                                                                    _createTextVNode("，新值为\"" + _toDisplayString(p2.NewLabel) + "\"", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (p2.State==3 && (index2==0 || p.IsOpen==true))
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_208, [
                                                                                    _createTextVNode("编辑了"),
                                                                                    _createElementVNode("span", _hoisted_209, _toDisplayString(p2.Label), 1),
                                                                                    _createTextVNode("，由\"" + _toDisplayString(p2.OldLabel) + "\"改为\"" + _toDisplayString(p2.NewLabel) + "\"", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (p2.State==2 && (index2==0 || p.IsOpen==true))
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
                                                                                    _createTextVNode("删除了"),
                                                                                    _createElementVNode("span", _hoisted_211, _toDisplayString(p2.Label), 1),
                                                                                    _createTextVNode("，原值为\"" + _toDisplayString(p2.NewLabel) + "\"", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (p2.State==999 && (index2==0 || p.IsOpen==true))
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_212, [
                                                                                    _createElementVNode("span", _hoisted_213, "未编辑" + _toDisplayString(p2.Label), 1),
                                                                                    _createTextVNode("，原值为\"" + _toDisplayString(p2.OldLabel) + "\"", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (p.IsOpen==false && index2==0)
                                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                                    key: 4,
                                                                                    onClick: ($event: any) => (p.IsOpen = !p.IsOpen),
                                                                                    style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                  }, [
                                                                                    _createVNode(_component_el_icon, null, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_Plus)
                                                                                      ]),
                                                                                      _: 1
                                                                                    })
                                                                                  ], 8, _hoisted_214))
                                                                                : _createCommentVNode("", true),
                                                                              (p.IsOpen==true && index2==0)
                                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                                    key: 5,
                                                                                    onClick: ($event: any) => (p.IsOpen = !p.IsOpen),
                                                                                    style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                  }, [
                                                                                    _createVNode(_component_el_icon, null, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_Minus)
                                                                                      ]),
                                                                                      _: 1
                                                                                    })
                                                                                  ], 8, _hoisted_215))
                                                                                : _createCommentVNode("", true),
                                                                              _hoisted_216
                                                                            ]))
                                                                          : (_openBlock(), _createElementBlock("div", _hoisted_217, [
                                                                              (p2.Title!=null && p2.Title!=undefined && p2.Title!='')
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_218, _toDisplayString(p2.Title), 1))
                                                                                : (_openBlock(), _createElementBlock("div", _hoisted_219, _toDisplayString(p2.NewLabel), 1))
                                                                            ])),
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p2.Child, (p3, index3) => {
                                                                          return (_openBlock(), _createElementBlock("div", {
                                                                            key: index3,
                                                                            style: {"line-height":"28px"}
                                                                          }, [
                                                                            (p3.State==4 && (index3==0 || p2.IsOpen==true))
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_220, [
                                                                                  _createTextVNode("新增了"),
                                                                                  _createElementVNode("span", _hoisted_221, _toDisplayString(p3.Label), 1),
                                                                                  _createTextVNode("，新值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                                ]))
                                                                              : _createCommentVNode("", true),
                                                                            (p3.State==3 && (index3==0 || p2.IsOpen==true))
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_222, [
                                                                                  _createTextVNode("编辑了"),
                                                                                  _createElementVNode("span", _hoisted_223, _toDisplayString(p3.Label), 1),
                                                                                  _createTextVNode("，由\"" + _toDisplayString(p3.OldLabel) + "\"改为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                                ]))
                                                                              : _createCommentVNode("", true),
                                                                            (p3.State==2 && (index3==0 || p2.IsOpen==true))
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
                                                                                  _createTextVNode("删除了"),
                                                                                  _createElementVNode("span", _hoisted_225, _toDisplayString(p3.Label), 1),
                                                                                  _createTextVNode("，原值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                                ]))
                                                                              : _createCommentVNode("", true),
                                                                            (p3.State==999 && (index3==0 || p2.IsOpen==true))
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_226, [
                                                                                  _createElementVNode("span", _hoisted_227, "未编辑" + _toDisplayString(p3.Label), 1),
                                                                                  _createTextVNode("，原值为\"" + _toDisplayString(p3.OldLabel) + "\"", 1)
                                                                                ]))
                                                                              : _createCommentVNode("", true),
                                                                            (p2.IsOpen==false && index3==0)
                                                                              ? (_openBlock(), _createElementBlock("div", {
                                                                                  key: 4,
                                                                                  onClick: ($event: any) => (p2.IsOpen = !p2.IsOpen),
                                                                                  style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                }, [
                                                                                  _createVNode(_component_el_icon, null, {
                                                                                    default: _withCtx(() => [
                                                                                      _createVNode(_component_Plus)
                                                                                    ]),
                                                                                    _: 1
                                                                                  })
                                                                                ], 8, _hoisted_228))
                                                                              : _createCommentVNode("", true),
                                                                            (p2.IsOpen==true && index3==0)
                                                                              ? (_openBlock(), _createElementBlock("div", {
                                                                                  key: 5,
                                                                                  onClick: ($event: any) => (p2.IsOpen = !p2.IsOpen),
                                                                                  style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                }, [
                                                                                  _createVNode(_component_el_icon, null, {
                                                                                    default: _withCtx(() => [
                                                                                      _createVNode(_component_Minus)
                                                                                    ]),
                                                                                    _: 1
                                                                                  })
                                                                                ], 8, _hoisted_229))
                                                                              : _createCommentVNode("", true),
                                                                            _hoisted_230
                                                                          ]))
                                                                        }), 128))
                                                                      ]))
                                                                    }), 128))
                                                                  ]))
                                                                : (_openBlock(), _createElementBlock("div", _hoisted_231, "—"))
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        _hoisted_232
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_233, [
                                                        (p.Child==null || p.Child==undefined || p.Child.length<=0)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_234, [
                                                              (p.State==4)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_235, [
                                                                    _createTextVNode("新增了"),
                                                                    _createElementVNode("span", _hoisted_236, _toDisplayString(p.Label), 1),
                                                                    _createTextVNode("，新值为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              (p.State==3)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_237, [
                                                                    _createTextVNode("编辑了"),
                                                                    _createElementVNode("span", _hoisted_238, _toDisplayString(p.Label), 1),
                                                                    _createTextVNode("，由\"" + _toDisplayString(p.OldLabel) + "\"改为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              (p.State==2)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_239, [
                                                                    _createTextVNode("删除了"),
                                                                    _createElementVNode("span", _hoisted_240, _toDisplayString(p.Label), 1),
                                                                    _createTextVNode("，原值为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              (p.State==999)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_241, [
                                                                    _createElementVNode("span", _hoisted_242, "未编辑" + _toDisplayString(p.Label), 1),
                                                                    _createTextVNode("，原值为\"" + _toDisplayString(p.OldLabel) + "\"", 1)
                                                                  ]))
                                                                : _createCommentVNode("", true)
                                                            ]))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_243, [
                                                              (p.Title!=null && p.Title!=undefined && p.Title!='')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_244, _toDisplayString(p.Title), 1))
                                                                : (_openBlock(), _createElementBlock("div", _hoisted_245, _toDisplayString(p.NewLabel), 1)),
                                                              _createElementVNode("div", _hoisted_246, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Child, (p3, index3) => {
                                                                  return (_openBlock(), _createElementBlock("div", {
                                                                    style: {"clear":"both"},
                                                                    key: index3
                                                                  }, [
                                                                    (p3.State==4)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_247, [
                                                                          _createTextVNode("新增了"),
                                                                          _createElementVNode("span", _hoisted_248, _toDisplayString(p3.Label), 1),
                                                                          _createTextVNode("，新值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                        ]))
                                                                      : _createCommentVNode("", true),
                                                                    (p3.State==3)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_249, [
                                                                          _createTextVNode("编辑了"),
                                                                          _createElementVNode("span", _hoisted_250, _toDisplayString(p3.Label), 1),
                                                                          _createTextVNode("，由\"" + _toDisplayString(p3.OldLabel) + "\"改为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                        ]))
                                                                      : _createCommentVNode("", true),
                                                                    (p3.State==2)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_251, [
                                                                          _createTextVNode("删除了"),
                                                                          _createElementVNode("span", _hoisted_252, _toDisplayString(p3.Label), 1),
                                                                          _createTextVNode("，原值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                        ]))
                                                                      : _createCommentVNode("", true),
                                                                    (p3.State==999)
                                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_253, [
                                                                          _createElementVNode("span", _hoisted_254, "未编辑" + _toDisplayString(p3.Label), 1),
                                                                          _createTextVNode("，原值为\"" + _toDisplayString(p3.OldLabel) + "\"", 1)
                                                                        ]))
                                                                      : _createCommentVNode("", true)
                                                                  ]))
                                                                }), 128)),
                                                                _hoisted_255
                                                              ]),
                                                              _hoisted_256
                                                            ]))
                                                      ]))
                                                ]))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["timestamp"]))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock("div", _hoisted_257, " 暂无数据 "))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _hoisted_258,
            _createElementVNode("div", _hoisted_259, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.settlementBottomButtons,
                "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.settlementBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickSettlement
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.oneSettlementForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.oneSettlementForm.Visiable,
          "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.oneSettlementForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"50%"},
          top: "20px",
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_260,
            _createElementVNode("div", _hoisted_261, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_262, [
              _createVNode(_component_el_form, {
                ref: "refOneSettlementForm",
                model: _ctx.oneSettlementForm,
                rules: _ctx.oneSettlementRules,
                "label-width": "120px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "待发放",
                    style: {"margin-top":"0px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.oneSettlementForm.BillCurrencySystemCode) + _toDisplayString(_ctx.formatNumber(_ctx.oneSettlementForm.NoSettlementPrice)), 1)
                    ]),
                    _: 1
                  }),
                  (_openBlock(), _createBlock(_component_el_form_item, {
                    label: "剩余",
                    style: _normalizeStyle([{"margin-top":"-10px"}, _ctx.oneSettlementForm.SurplusPrice<0?'color:red':'']),
                    key: _ctx.randomPrice
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.oneSettlementForm.BillCurrencySystemCode) + _toDisplayString(_ctx.formatNumber(_ctx.oneSettlementForm.SurplusPrice)), 1)
                    ]),
                    _: 1
                  }, 8, ["style"])),
                  _createVNode(_component_el_form_item, {
                    label: "折算后",
                    style: {"margin-top":"-10px","display":"none"},
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.oneSettlementForm.BillCurrencySystemCode) + _toDisplayString(_ctx.formatNumber(_ctx.oneSettlementForm.ConvertPrice)), 1)
                    ]),
                    _: 1
                  }),
                  (_ctx.isSalerPerformance == true && _ctx.items.Data.IsOneMonth != true)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "所属月份"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            "no-data-text": '无匹配信息',
                            "no-match-text": '无匹配信息',
                            onChange: _cache[70] || (_cache[70] = ($event: any) => (_ctx.onChangeMonth())),
                            modelValue: _ctx.oneSettlementForm.SelectMonth,
                            "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.oneSettlementForm.SelectMonth) = $event)),
                            filterable: "",
                            placeholder: "请选择"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oneSettlementForm.Months, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  disabled: item.Disabled,
                                  key: item.Value,
                                  label: item.Label,
                                  value: item.Value
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_263, _toDisplayString(item.Label), 1),
                                    (item.Disabled==true)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_264, "暂无应发金额"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: "本次发放金额",
                    prop: "Price"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_miezz_input, {
                        placeholder: "请填写",
                        disabled: false,
                        onBlur: _cache[72] || (_cache[72] = ($event: any) => (_ctx.onChangePrice())),
                        modelValue: _ctx.oneSettlementForm.Price,
                        "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.oneSettlementForm.Price) = $event)),
                        number: true,
                        pattern: "[-0-9.,]"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "时间",
                    prop: "SettlementDate"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.oneSettlementForm.SettlementDate,
                        "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.oneSettlementForm.SettlementDate) = $event)),
                        format: "YYYY/MM/DD HH:mm",
                        type: "datetime",
                        style: {"width":"100% !important"},
                        placeholder: "请选择"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "收款方",
                    prop: "CollectionTitle"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_miezz_input, {
                        placeholder: "请填写",
                        disabled: false,
                        modelValue: _ctx.oneSettlementForm.CollectionTitle,
                        "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.oneSettlementForm.CollectionTitle) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "付款方",
                    prop: "PaymentTitle"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_miezz_input, {
                        placeholder: "请填写",
                        disabled: false,
                        modelValue: _ctx.oneSettlementForm.PaymentTitle,
                        "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.oneSettlementForm.PaymentTitle) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "备注",
                    prop: "Remark"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.oneSettlementForm.Remark,
                        "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.oneSettlementForm.Remark) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]),
            _hoisted_265,
            _createElementVNode("div", _hoisted_266, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.oneSettlementBottomButtons,
                "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.oneSettlementBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickOneSettlement
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.grossProfitDetailForm.Visible,
      "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.grossProfitDetailForm.Visible) = $event)),
      "show-close": false,
      style: {"width":"80%"},
      top: "0px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_267,
        _createElementVNode("div", _hoisted_268, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_269, [
          _createElementVNode("div", _hoisted_270, [
            _hoisted_271,
            (_ctx.result.GrossProfit.GrossProfitDetail!=null && _ctx.result.GrossProfit.GrossProfitDetail.CollectionDetail!='')
              ? (_openBlock(), _createElementBlock("span", _hoisted_272, _toDisplayString(_ctx.result.GrossProfit.GrossProfitDetail.CollectionDetail), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_273, "CNY 0"))
          ]),
          _createElementVNode("div", _hoisted_274, [
            _hoisted_275,
            (_ctx.result.GrossProfit.GrossProfitDetail!=null && _ctx.result.GrossProfit.GrossProfitDetail.PaymentDetail!='')
              ? (_openBlock(), _createElementBlock("span", _hoisted_276, _toDisplayString(_ctx.result.GrossProfit.GrossProfitDetail.PaymentDetail), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_277, "CNY 0")),
            (_ctx.result.GrossProfit.GrossProfitDetail.IsShare == false)
              ? (_openBlock(), _createElementBlock("span", _hoisted_278, [
                  _createTextVNode(" 存在未分摊应付费用 "),
                  _createElementVNode("span", {
                    style: {"margin-left":"10px","cursor":"pointer","color":"#fe995b"},
                    onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.onShare()))
                  }, " 查看账单 ")
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_279, [
            _hoisted_280,
            (_ctx.result.GrossProfit.GrossProfitDetail!=null && _ctx.result.GrossProfit.GrossProfitDetail.GrossProfitDetail!='')
              ? (_openBlock(), _createElementBlock("span", _hoisted_281, _toDisplayString(_ctx.result.GrossProfit.GrossProfitDetail.GrossProfitDetail), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_282, "CNY 0"))
          ]),
          _createElementVNode("div", _hoisted_283, [
            _hoisted_284,
            _createElementVNode("span", null, _toDisplayString(_ctx.isString(_ctx.result.GrossProfit.GrossProfitDetail.GrossPointDetail)), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_table, {
            stripe: "",
            border: "",
            "tree-props": {children: 'Child', hasChildren: 'hasChildren'},
            "row-key": "Id",
            "default-expand-all": false,
            data: _ctx.result.GrossProfit.GrossProfitDetail.Pools,
            ref: "$grossProfitDetailTable",
            style: {"width":"100%","margin-top":"15px"},
            "header-cell-style": { 'text-align': 'left' },
            "cell-style": { 'text-align': 'left' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "scope.row.BookingNo",
                label: "BookingNo",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_285, _toDisplayString(_ctx.isString(scope.row.BookingNo)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.ClientCompany",
                label: "委托公司",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_286, _toDisplayString(_ctx.isString(scope.row.ClientCompany)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.CustomerServiceLabel",
                label: "客服",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_287, _toDisplayString(_ctx.isString(scope.row.CustomerServiceLabel)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Collection",
                label: "应收合计",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_288, _toDisplayString(_ctx.isString(scope.row.Collection)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Collection",
                label: "应收坏账",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_289, _toDisplayString(_ctx.isString(scope.row.BadCollectionSettlement)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Payment",
                label: "应付合计",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_290, _toDisplayString(_ctx.isString(scope.row.Payment)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Payment",
                label: "应付坏账",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_291, _toDisplayString(_ctx.isString(scope.row.BadPaymentSettlement)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Profit",
                label: "毛利润合计",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    style: _normalizeStyle([scope.row.IsProfit==true?'color:red;':'', {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}])
                  }, _toDisplayString(_ctx.isString(scope.row.Profit)), 5)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.GrossPointString",
                label: "单票毛利率",
                "show-overflow-tooltip": true,
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_292, _toDisplayString(_ctx.isString(scope.row.GrossPointString)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Collection",
                label: "操作",
                "show-overflow-tooltip": true,
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.onPool(scope.row)),
                    style: {"cursor":"pointer","color":"#fe995b","width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                  }, " 查看账单 ", 8, _hoisted_293)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _hoisted_294,
        _createVNode(_component_miezz_button_bar, {
          modelValue: _ctx.grossProfitDetailBottomButtons,
          "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.grossProfitDetailBottomButtons) = $event)),
          isBackground: true,
          onHandleClick: _ctx.handleClickGrossProfitDetail
        }, null, 8, ["modelValue", "onHandleClick"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.settlementVisible,
      "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.settlementVisible) = $event)),
      "show-close": false,
      style: {"width":"80%"},
      top: "0px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_295,
        _createElementVNode("div", _hoisted_296, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_table, {
            stripe: "",
            border: "",
            "tree-props": {children: 'Child', hasChildren: 'hasChildren'},
            "row-key": "Id",
            "default-expand-all": false,
            data: _ctx.result.Settlements,
            ref: "$settlementTable",
            style: {"width":"100%","margin-top":"15px"},
            "header-cell-style": { 'text-align': 'left' },
            "cell-style": { 'text-align': 'left' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "scope.row.BookingNo",
                label: "BookingNo",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_297, _toDisplayString(_ctx.isString(scope.row.BookingNo)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.OrderCode",
                label: "订单编号",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_298, _toDisplayString(_ctx.isString(scope.row.OrderCode)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Price",
                label: "核销金额",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_299, _toDisplayString(_ctx.isString(scope.row.CurrencySystemCode)) + _toDisplayString(_ctx.isString(_ctx.formatNumber(scope.row.Price))), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Rate",
                label: "汇率",
                "show-overflow-tooltip": true,
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.Mode != '坏账核销')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_300, _toDisplayString(_ctx.isString(scope.row.Rate)), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_301, " — "))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.SettlementDate",
                label: "核销时间",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_302, _toDisplayString(_ctx.isString(scope.row.SettlementDate)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.CollectionTitle",
                label: "收款方",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  (scope.row.Mode != '坏账核销')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_303, _toDisplayString(_ctx.isString(scope.row.CollectionTitle)), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_304, " — "))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.PaymentTitle",
                label: "付款方",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  (scope.row.Mode != '坏账核销')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_305, _toDisplayString(_ctx.isString(scope.row.PaymentTitle)), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_306, " — "))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Mode",
                label: "核销方式",
                "show-overflow-tooltip": true,
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_307, _toDisplayString(_ctx.isString(scope.row.Mode)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Remark",
                label: "备注",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_308, _toDisplayString(_ctx.isString(scope.row.Remark)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _hoisted_309,
        _createVNode(_component_miezz_button_bar, {
          modelValue: _ctx.settlementDetailBottomButtons,
          "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => ((_ctx.settlementDetailBottomButtons) = $event)),
          isBackground: true,
          onHandleClick: _ctx.handleClickSettlementDetail
        }, null, 8, ["modelValue", "onHandleClick"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [
      _directive_loading,
      _ctx.isLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}